import { Component } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';
import { Globals } from '../../../../globals';

/**
 * Generated class for the StockListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-popup-print',
  templateUrl: 'popup-print.html',
})
export class PopupPrintPage {
  origin: any;
  msg: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    public globals: Globals) {
    this.origin = this.navParams.get('origin');
    this.msg = this.navParams.get('msg');
  }

  close() {
    this.viewCtrl.dismiss();
  }

  openLink() {
    if (this.globals.so_mobile) {
      window.location.assign('https://printerservices.mycheftool.com/');
    } else {
      window.open('https://printerservices.mycheftool.com/', '_blank');
    }
  }

  openConfPrinters() {
    let data = { 'open_conf_page': true };
    this.viewCtrl.dismiss(data);
  }


}


// WEBPACK FOOTER //
// ./src/pages/components/popups/popup-print/popup-print.ts